// Constants from utils
export const HUNDRED = 100;
export const THOUSAND = 1000;
export const LAKH = HUNDRED * THOUSAND;
export const CRORE = HUNDRED * LAKH;
export const MILLION = THOUSAND * THOUSAND;
export const BILLION = THOUSAND * MILLION;
